import React from "react";
import styled from "styled-components";

import { Skeleton } from "@ui/Atoms/Skeleton";
import * as Grid from "@ui/Atoms/Grid";

const GiftCardsSkeleton = React.memo(() => (
  <Grid.Container>
    <Grid.Row>
      <Grid.Column md={10} pushMd={1} lg={8} pushLg={2}>
        <StyledSkeleton shape="row" />
      </Grid.Column>
    </Grid.Row>
  </Grid.Container>
));

GiftCardsSkeleton.displayName = "GiftCardsSkeleton";

export { GiftCardsSkeleton };

const StyledSkeleton = styled(Skeleton)`
  height: 80vh;
  margin: ${props => props.theme.spacing.spacing_16} 0;
`;
